module.exports = __webpack_public_path__ + "static/media/logo.456a71f3.svg";